// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .btn-submit {
  background-color: #0060d6;
  color: #ffff;
  transition: background 0.3s ease-in-out;

  &:hover{
     background-color: #1a1a86;
  }
}
  .btn-outline-submit{
  color: #1a1a86;
  background: transparent;
  border-color: #1a1a86;

  &:hover{
    color: white;
    background: #1a1a86;

  }
  }`, "",{"version":3,"sources":["webpack://./src/app/features/digital-identity/shared/dialogs/import-fail-dialog.component.ts"],"names":[],"mappings":"EAAE;EACA,yBAAyB;EACzB,YAAY;EACZ,uCAAuC;;EAEvC;KACG,yBAAyB;EAC5B;AACF;EACE;EACA,cAAc;EACd,uBAAuB;EACvB,qBAAqB;;EAErB;IACE,YAAY;IACZ,mBAAmB;;EAErB;EACA","sourcesContent":["  .btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n     background-color: #1a1a86;\n  }\n}\n  .btn-outline-submit{\n  color: #1a1a86;\n  background: transparent;\n  border-color: #1a1a86;\n\n  &:hover{\n    color: white;\n    background: #1a1a86;\n\n  }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
